import styled from "@mui/styled-engine-sc";
import TextField from "@mui/material/TextField";
import { dimensions } from "../../themes/variables";
import { palette } from "../../themes/color-palette";
import FormHelperText from "@mui/material/FormHelperText";
import { SvgClose } from "../../components/svg/close";
import { SvgSuccess } from "../../components/svg/success";
import { Input } from "@mui/material";
import { StyledBox } from "../box/styled-box";

const CustomTextField = (props: any) => {
  const textFieldProps = { ...props };
  delete textFieldProps.success;
  return (
    <>
      {textFieldProps.endAdornment ? (
        <Input {...textFieldProps} />
      ) : (
        <>
          <TextField variant="outlined" {...textFieldProps} helperText="" />
          {props.error && (
            <FormHelperText id={`erreur-${props.id || "input"}`} error sx={{ display: "flex", alignItems: "center" }}>
              <SvgClose className="error" />
              <StyledBox component="span" sx={{ color: "primary.main" }}>
                {props.helperText}
              </StyledBox>
            </FormHelperText>
          )}
        </>
      )}

      {/* {props.error && (
        <FormHelperText id={`erreur-${props.id || "input"}`} error sx={{ display: "flex", alignItems: "center" }}>
          <SvgClose className="error" />
          {props.helperText}
        </FormHelperText>
      )} */}
      {props.success && (
        <FormHelperText
          id={`succes-${props.id || "input"}`}
          sx={{ display: "flex", alignItems: "center", color: palette.success.main }}>
          <SvgSuccess className="success" />
          {props.helperText}
        </FormHelperText>
      )}
    </>
  );
};

const StyledTextField = styled(CustomTextField)<{ welcomeOfferPopin?: boolean }>`
  ${({ theme, welcomeOfferPopin }) => `
  //margin: 0;

  "& .MuiFormLabel-asterisk": {
    color: "red",
  },

  .MuiOutlinedInput-root {
    &:hover {
      &:not(.Mui-focused) .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.palette.text.secondary};
      }
      .MuiInputLabel-outlined {
        color: ${theme.palette.primary.main};
      }
    }

    &.Mui-focused fieldset {
      border: 1px solid currentcolor;
    }

    legend {
      width: 0px !important;
    }
  }



  .MuiOutlinedInput-input {
    padding-top: 0;
    padding-bottom: 0;
    font-weight: 500;
    color: ${theme.palette.text.primary};
    height: ${welcomeOfferPopin ? "49px" : `${dimensions.inputFields.height}px`};
    background: ${palette.white.main};
     border-radius: ${welcomeOfferPopin ? "2px" : `${theme.shape.borderRadius}px`};
    //border: ${palette.gray.neutralGray600} 1px solid;

    ${theme.breakpoints.down("sm")} {
    height: ${welcomeOfferPopin ? "40px" : `${dimensions.inputFields.height}px`};
  }
  }

  .MuiInputLabel-outlined {
    transform: none;
    position: relative;
    margin-bottom: ${theme.spacing(1)};
    font-weight: 500;
    color: ${theme.palette.text.secondary};
    z-index: unset;
    pointer-events: unset;

    &.Mui-focused {
      color: ${theme.palette.text.primary};
      border-color: ${theme.palette.text.primary};

    }

    &.Mui-disabled {
      color: ${theme.palette.text.disabled};
    }
  }

  .MuiFormHelperText-contained {
    margin: ${theme.spacing(1)} 0 0 ${theme.spacing(4)};
    color: ${theme.palette.primary.main};
    &:before {
      position: absolute;
      content: "";
      background-color: ${theme.palette.gray.neutralGray600};
    }
  }

  .MuiOutlinedInput-root.Mui-disabled {
    color: ${theme.palette.text.disabled};

    &:hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.palette.text.disabled};
      }
    }

    .MuiOutlinedInput-input {
      color: ${theme.palette.text.disabled};
      background: ${theme.palette.action.disabledBackground};
     border-radius: ${welcomeOfferPopin ? "2px" : `${theme.shape.borderRadius}px`};
    }

    .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.palette.text.disabled};
    }
  }

  .MuiInputBase-input {
    &::placeholder {
      color: ${theme.palette.gray.neutralGray600};
      opacity: 1;
    }
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  input[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;
  }


  .MuiInputBase-inputSizeSmall {
    height: 40px;
  }

  &.border-gray-300 {
    .MuiInputLabel-outlined {
      color: ${palette.gray.neutralGray600};
    }
    .MuiOutlinedInput-input {
      //border: ${palette.gray.neutralGray300} 1px solid;
    }
    .MuiOutlinedInput-root.Mui-focused fieldset {
      border-color: ${palette.gray.neutralGray300};
    }

    .MuiOutlinedInput-root:hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${palette.gray.neutralGray300};
      }
    }
    &.text-big {
      background: ${palette.white.main};
      border-radius: 8px;

      .MuiOutlinedInput-root {
        padding: ${theme.spacing(2.5)} ${theme.spacing(3)};
      }
      .MuiInputBase-input {
        font-size: 20px;
        font-weight: 700;
        margin-top: 0;
        border-radius: 0;
      }
    }
  }

  &.border-gray-500 {
    .MuiOutlinedInput-input {
      &::placeholder {
        color: ${palette.gray.neutralGray900};
      }
    }
    .MuiInputLabel-outlined {
      color: ${palette.gray.neutralGray900};
    }
    .MuiOutlinedInput-root.Mui-focused fieldset {
      border-color: ${palette.gray.neutralGray500};
      border-radius: 0;
    }

    .MuiOutlinedInput-root:hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${palette.gray.neutralGray500};
      }
    }
  }

  label.Mui-required {
    .MuiInputLabel-asterisk {
      display: none;
    }
  }

  &.underline-gray {
    .MuiInputLabel-root {
      color: ${palette.gray.neutralGray600};
      font-weight: 400;

      &.Mui-disabled {
        transform: translate(0, -1.5px) scale(0.75);
      }
    }
    .MuiInputBase-root {
      height: auto;
      &:before {
        border-bottom: ${palette.gray.neutralGray400} 1px solid;
      }
      &:hover {
        &:not(.Mui-disabled) {
          &:after {
            border-bottom: ${palette.gray.neutralGray500} 1px solid;
          }
        }
      }
      &:after {
        border-bottom: ${palette.gray.neutralGray400} 1px solid;
      }
      &.Mui-error {
        &:before {
          border-bottom: 0;
        }
        &:after {
          border-bottom-color: ${palette.primary.main};
        }
      }
      .MuiInputBase-input {
        font-weight: 400;

        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus {
          -webkit-box-shadow: 0 0 0px 1000px ${palette.blue.extraLight} inset !important;
        }
      }
    }
    &.text-big {
      .MuiInputBase-input {
        font-size: 20px;
        text-transform: uppercase;
        font-weight: 700;
        margin-top: 0;
      }
    }
    &.bg-beige {
      .MuiInputBase-input {
        font-weight: 400;

        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus {
          -webkit-box-shadow: 0 0 0px 1000px ${palette.beige.light} inset !important;
        }
      }
    }
    &.optional {
      .MuiInput-root {
        &:before {
          border-bottom: ${palette.gray.neutralGray300} 1px solid;
        }
        &:after {
          border-bottom: ${palette.gray.neutralGray300} 1px solid;
        }
      }
    }
  }
  `}
    &.styled-v2 {
    .MuiInputLabel-root {
      color: #212121;
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 9px;

      &.Mui-focused {
        color: #212121;
      }
    }
    label + .MuiInputBase-formControl {
      margin-top: 21px;
      padding: 0
    }
    .MuiAutocomplete-popupIndicator {
        position: relative;
        top: 8px;
        right: 10px;
    }
    .MuiOutlinedInput-root {
      border-radius: 8px;
      background: #ffffff;
      .MuiOutlinedInput-notchedOutline {
        border: 2px solid #e7eaee;
      }
      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: #cfd3d8;
      }
      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #212121;
      }
    }

    .MuiAutocomplete-inputRoot{
          padding-right: 0 !important;
    }

    .MuiAutocomplete-clearIndicator{
          top: 8px;
          position: relative;
          margin-right: 9px;
    }

    .MuiInputBase-input {
      padding: 12px 18px !important;
      background: #ffffff;
      border-radius: 8px;
      border: 2px solid #E7EAEE;
      color: #000000;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
    }

    .MuiInputBase-inputMultiline{
      height: 72px !important;
    }

    .MuiInputBase-formControl:after,
    .MuiInputBase-formControl:before{
      display: none;
    }
    }
  }
`;

export { StyledTextField };
